import { startInactivityWatch } from "@/common/inactivity";
import { Modal } from "ant-design-vue";
 
export default {
  install(app, options = {}) {
    const {
      router,
      store,
      axiosInstance,
      loginRoute = "/login",
      publicPaths = ["/login"],
      protectRoutes = true,
    } = options;
 
    if (!router || !store) {
      console.error("[session-timeout] router and store are required");
      return;
    }
 
    let inactivityController = null;
    let warnModalDestroy = null;
    let countdownInterval = null; 
 
    function closeWarn() {
      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
      }
      if (warnModalDestroy) {
        warnModalDestroy();
        warnModalDestroy = null;
      }
    }
 
    function forceReauth() {
      closeWarn();
 
      if (inactivityController) {
        inactivityController.stop();
        inactivityController = null;
      }
 
      // Clear app auth state + tokens
      try {
        localStorage.removeItem("access_token");
        localStorage.removeItem("id_token");
        localStorage.removeItem("user_name");
      } catch (e) {
        console.warn("Failed clearing auth items from localStorage:", e);
      }
 
      try {
        localStorage.removeItem("selectedClient");
      } catch (e) {
        console.warn("Failed removing selectedClient:", e);
      }
 
      // Vuex logout
      if (store?.commit) {
        try {
          store.commit("auth/LOGOUT");
        } catch (e) {
          console.warn("Store logout commit failed:", e);
        }
      }
 
      try {
        const ax = axiosInstance;
        if (ax?.defaults?.headers?.common?.Authorization) {
          delete ax.defaults.headers.common.Authorization;
        }
      } catch (e) {
        console.warn("Failed clearing axios Authorization header:", e);
      }
 
      try {
        localStorage.setItem("postLoginRedirect", window.location.href);
      } catch (e) {
        console.warn("Failed setting postLoginRedirect:", e);
      }
 
      router.replace(loginRoute).catch(() => {});
    }
 
    // Dismiss-only warning 
    function warnUser() {
      if (warnModalDestroy) return;
 
      let secondsLeft = 5 * 60; // 5 minutes
      const msg = () =>
        `You’ll be signed out in ${Math.ceil(secondsLeft / 60)} minutes due to inactivity.`;
 
      const instance = Modal.confirm({
        title: "Session expiring soon",
        content: msg(),
        okText: "Dismiss",
        okCancel: false,     
        maskClosable: false, // clicking outside does NOT dismiss
        keyboard: false, // ESC does NOT dismiss
        onOk: () => {
          closeWarn();
        },
      });
 
      warnModalDestroy = instance.destroy;
 
      countdownInterval = setInterval(() => {
        secondsLeft -= 5;
        if (secondsLeft <= 0 || !warnModalDestroy) {
          clearInterval(countdownInterval);
          countdownInterval = null;
          return;
        }
        instance.update({ content: msg() });
      }, 5000);
    }
 
    router.isReady().then(() => {
      const isLogin = router.currentRoute.value?.path === loginRoute;
      const isLoggedIn = !!(store.state && store.state.auth && store.state.auth.loggedIn);
 
      if (isLoggedIn && !isLogin && !inactivityController) {
        inactivityController = startInactivityWatch(forceReauth, warnUser);
      }
 
      router.afterEach(() => {
        if (inactivityController) inactivityController.ping();
      });
 
      window.addEventListener("beforeunload", () => {
        if (inactivityController) {
          inactivityController.stop();
          inactivityController = null;
        }
      });
    });
 
    if (protectRoutes) {
      router.beforeEach((to, from, next) => {
        const requiresAuth = !publicPaths.includes(to.path);
        const isLoggedIn = !!(store.state && store.state.auth && store.state.auth.loggedIn);
 
        if (requiresAuth && !isLoggedIn) {
          try {
            localStorage.setItem("postLoginRedirect", to.fullPath);
          } catch (e) {
            console.warn("Failed setting postLoginRedirect:", e);
          }
          return next(loginRoute);
        }
        next();
      });
    }
  },
};